import axios, { AxiosError } from 'axios';
import { EHttpStatusCode } from './type';
import { auth } from '@my-account/tools';
import Configs from 'config';

const axiosInstance = axios.create({
    baseURL: Configs.API_BASE_URL,
});

axiosInstance.interceptors.request.use(async config => {
    const token = await auth.getToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
});

axiosInstance.interceptors.response.use(
    response => response,
    (error: AxiosError) => {
        if (EHttpStatusCode.UNAUTHORIZED === error.response?.status) {
            auth.logout();
        }
        return Promise.reject(error);
    },
);

export default axiosInstance;
